const Footer = () => {
  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Process', href: '#process' },
    { label: 'Industries', href: '#industries' },
    { label: 'Solution', href: '#solution' },
  ];

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ background: '#1E1B4B' }} className="relative overflow-hidden">
      {/* Top accent border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-violet/40 to-transparent" />
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/3 w-64 h-32 rounded-full bg-brand-violet/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand column */}
          <div className="md:col-span-2">
            <a href="/" className="inline-flex items-center gap-3 mb-5 cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/c0a88de9-38fc-4f88-a1f1-70c076e7f78c.png"
                alt="Workflow Wizards AI"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: 'contain',
                }}
              />
            </a>
            <p className="font-inter text-white/50 text-sm leading-relaxed max-w-xs mb-6">
              Intelligent workflow automation for service-based businesses. We turn fragmented operations into connected, automated systems.
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-linkedin-fill', href: '#' },
                { icon: 'ri-twitter-x-line', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-youtube-line', href: '#' },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/8 hover:bg-white/15 transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${social.icon} text-white/60 text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-space font-semibold text-white text-sm mb-5">Navigation</h4>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleAnchorClick(e, link.href)}
                    className="font-inter text-sm text-white/50 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-space font-semibold text-white text-sm mb-5">Get in Touch</h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-brand-teal text-sm" />
                </div>
                <span className="font-inter text-sm text-white/50">hello@workflowwizards.ai</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-brand-teal text-sm" />
                </div>
                <span className="font-inter text-sm text-white/50">+1 (800) 555-0199</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-brand-teal text-sm" />
                </div>
                <span className="font-inter text-sm text-white/50">Remote-first — Serving businesses worldwide</span>
              </div>
            </div>

            <button
              onClick={() => document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' })}
              className="whitespace-nowrap mt-6 font-inter font-semibold text-xs text-brand-indigo px-5 py-2.5 rounded-lg bg-brand-teal hover:opacity-90 transition-opacity cursor-pointer inline-flex items-center gap-2"
            >
              Book a Demo
              <i className="ri-calendar-line" />
            </button>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-inter text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Workflow Wizards AI. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {['Privacy Policy', 'Terms of Service'].map((item) => (
              <a key={item} href="#" className="font-inter text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
